export default "__VITE_PUBLIC_ASSET__317ebe88__"